<div>
  <div style="display: flex; align-items: flex-end; gap: 15px; height: 40px">
    <div class="expanded-info-section-title">{{ 'Settings.Receivers' | translate }}</div>
    <div (click)="show = !show" style="cursor: pointer">
      <mat-icon style="font-size: 24px" *ngIf="show">keyboard_arrow_up</mat-icon>
      <mat-icon style="font-size: 24px" *ngIf="!show">chevron_right</mat-icon>
    </div>
  </div>

  <div *ngIf="show" class="table-container scrollbar">
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <mat-header-cell class="header-cell" *matHeaderCellDef>
          {{ 'Settings.ReceiverName' | translate }}
        </mat-header-cell>

        <mat-cell class="cell" *matCellDef="let row">
          <div style="display: flex; align-items: center; gap: 10px">
            <img class="receiver-logo" [src]="row.logo ?? company.logo ?? 'assets/img/citymesh-logo-user.png'" alt />
            <div>{{ row.name || '-' }}</div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="apiKey">
        <mat-header-cell *matHeaderCellDef class="header-cell"> {{ 'Settings.Apikey' | translate }} </mat-header-cell>

        <mat-cell *matCellDef="let row" class="cell"> {{ row.apiKey || '-' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="ip">
        <mat-header-cell class="header-cell" *matHeaderCellDef> {{ 'Settings.IP' | translate }} </mat-header-cell>

        <mat-cell class="cell" *matCellDef="let row"> {{ row.ip ? convertToName(row.ip) : '-' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="monitoringPort">
        <mat-header-cell *matHeaderCellDef class="header-cell">
          {{ 'Settings.MonitoringPort' | translate }}
        </mat-header-cell>

        <mat-cell class="cell" *matCellDef="let row"> {{ row.monitoringPort || '-' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="receiverEventPort">
        <mat-header-cell *matHeaderCellDef class="header-cell"> {{ 'Settings.UdpPort' | translate }} </mat-header-cell>

        <mat-cell class="cell" *matCellDef="let row"> {{ row.receiverEventPort || '-' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="snifferPort">
        <mat-header-cell *matHeaderCellDef class="header-cell">
          {{ 'Settings.SnifferPort' | translate }}
        </mat-header-cell>

        <mat-cell class="cell" *matCellDef="let row"> {{ row.snifferPort || '-' }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></mat-row>
    </mat-table>
  </div>
</div>
